export default function Nosotros() {

  const anioInicioClinico = 2017;
  const anioInicioEstetica = 2022;

  const aniosExperiencia = new Date().getFullYear() - anioInicioClinico;
  const aniosEstetica = new Date().getFullYear() - anioInicioEstetica;

  return (
    <section className="py-16 md:py-20">
      <div className="mx-auto max-w-6xl px-4">

        <div className="grid gap-10 lg:grid-cols-[1.05fr_0.95fr] lg:items-start">

          {/* LEFT */}
          <div className="min-w-0">
            <p className="text-sm font-medium text-[color:var(--c1)]">
              Nuestra especialista
            </p>

            <h2 className="mt-3 text-4xl md:text-5xl font-semibold tracking-tight leading-[1.05]">
              EU. Belén Rojas Espinosa
            </h2>

            <div className="mt-6 space-y-6">

              <p
                className="text-base md:text-lg text-[color:var(--muted)] leading-relaxed"
                style={{ textAlign: "justify" }}
              >
                Con más de {aniosExperiencia} años de experiencia clínica y desde hace {aniosEstetica} años inmersa en el maravilloso mundo de la estética y cuidado de la piel. Su enfoque se basa en una visión bioregenerativa y personalizada, comprendiendo la piel como un reflejo del equilibrio interno.
              </p>

              <p
                className="text-base md:text-lg text-[color:var(--muted)] leading-relaxed"
                style={{ textAlign: "justify" }}
              >
                Cuenta con formación continua en Dermoestética avanzada, bioestimulación de colágeno, antiaging e inflammaging, integrando ciencia, innovación y criterio clínico en cada procedimiento.
              </p>

              <p
                className="text-base md:text-lg text-[color:var(--muted)] leading-relaxed"
                style={{ textAlign: "justify" }}
              >
                Fundadora de BELSKIN NURSE, donde promueve una estética consciente que busca resaltar la belleza propia, respetando la identidad de cada paciente.
              </p>

              <p
                className="text-base md:text-lg text-[color:var(--muted)] leading-relaxed"
                style={{ textAlign: "justify" }}
              >
                “Creo en una estética que no transforma quién eres, sino que potencia lo que ya habita en ti.”
              </p>

            </div>

            {/* Pills */}
            <div className="mt-8 grid sm:grid-cols-2 gap-3">
              <MiniPill>Protocolos seguros</MiniPill>
              <MiniPill>Atención personalizada</MiniPill>
              <MiniPill>Enfoque clínico</MiniPill>
              <MiniPill>Visión integrativa</MiniPill>
            </div>

          </div>

          {/* RIGHT */}
          <div className="relative lg:sticky lg:top-24">
            <div className="rounded-[28px] border border-[color:var(--border)] bg-[color:var(--bg)] p-4 md:p-6 shadow-[0_14px_40px_rgba(0,0,0,0.06)]">

              <div className="relative overflow-hidden rounded-[24px]">

                <img
                  src="/img/about1.jpeg"
                  alt="Especialista"
                  className="h-[520px] w-full object-cover"
                  loading="lazy"
                />

                {/* Overlay */}
                <div className="absolute inset-x-4 bottom-4 z-10">
                  <div
                    style={{ backgroundColor: "rgba(128, 171, 165, 0.60)" }}
                    className="
                      rounded-2xl
                      border border-white/25
                      backdrop-blur-xl backdrop-saturate-150
                      shadow-[0_18px_50px_rgba(0,0,0,0.22)]
                      ring-1 ring-white/15
                      p-5
                    "
                  >

                    <p className="text-white/90 text-sm font-medium leading-relaxed">
                      Enfermera Universitaria y Licenciada en Enfermeria.
                    </p>

                    <p className="mt-3 text-white/90 text-sm font-medium leading-relaxed">
                      Diplomada en Dermoestética inyectable y cuidado de la piel en la Academia Chilena de Enfermeria Estética. ACEE.
                    </p>

                    {/* Social */}
                    <div className="mt-4 flex items-center gap-3">
                      <IconButton
                        href="https://www.instagram.com/bel.skinurse/"
                        label="Instagram"
                      >
                        <InstagramIcon />
                      </IconButton>

                      <IconButton
                        href="https://web.facebook.com/Bel.skinurse/?_rdc=1&_rdr#"
                        label="Facebook"
                      >
                        <FacebookIcon />
                      </IconButton>

                      <IconButton
                        href="https://wa.me/56920910798"
                        label="WhatsApp"
                      >
                        <WhatsAppIcon />
                      </IconButton>
                    </div>

                  </div>
                </div>

                <div className="pointer-events-none absolute inset-x-0 bottom-0 h-56 bg-gradient-to-t from-black/60 via-black/25 to-transparent" />

              </div>

            </div>
          </div>

        </div>

      </div>
    </section>
  );
}


/* Pills */

function MiniPill({ children }) {
  return (
    <div className="flex items-center gap-2 rounded-2xl border border-[color:var(--border)] bg-white/70 backdrop-blur px-4 py-3 min-h-[56px]">
      <span className="h-2 w-2 rounded-full bg-[color:var(--c2)] shrink-0" />
      <span className="text-sm text-[color:var(--ink)] leading-snug">
        {children}
      </span>
    </div>
  );
}


/* Icon Button */

function IconButton({ href, label, children }) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      className="
        h-10 w-10 rounded-xl
        bg-white/20 border border-white/25
        flex items-center justify-center
        hover:bg-white/30 transition
        text-white
      "
      aria-label={label}
      title={label}
    >
      {children}
    </a>
  );
}


/* Icons */

function InstagramIcon() {
  return (
    <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="2">
      <rect x="3" y="3" width="18" height="18" rx="5" />
      <path d="M16 11.37a4 4 0 1 1-7.88 1.26A4 4 0 0 1 16 11.37z" />
      <path d="M17.5 6.5h.01" />
    </svg>
  );
}

function FacebookIcon() {
  return (
    <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
    </svg>
  );
}

function WhatsAppIcon() {
  return (
    <svg viewBox="0 0 32 32" className="h-5 w-5" fill="currentColor">
      <path d="M16 3C9.37 3 4 8.37 4 15c0 2.64.86 5.08 2.31 7.06L4 29l7.13-2.27C13.06 27.43 14.5 28 16 28c6.63 0 12-5.37 12-12S22.63 3 16 3zm6.62 17.09c-.28.8-1.39 1.49-2.26 1.67-.59.12-1.36.17-4.39-.94-3.87-1.35-6.36-4.83-6.55-5.08-.18-.24-1.57-2.09-1.57-3.99 0-1.9.99-2.84 1.34-3.23.35-.39.77-.49 1.03-.49h.74c.24 0 .56-.09.87.66.31.74 1.05 2.59 1.14 2.78.09.19.15.42.03.67-.12.24-.18.39-.36.6-.18.21-.38.47-.54.63-.18.18-.37.37-.16.73.21.35.95 1.57 2.04 2.54 1.4 1.25 2.58 1.64 2.94 1.82.36.18.57.15.78-.09.21-.24.9-1.05 1.14-1.41.24-.36.48-.3.8-.18.33.12 2.07.98 2.43 1.16.36.18.6.27.69.42.09.15.09.87-.19 1.67z" />
    </svg>
  );
}